import NumberCardWrapper from "./src/number-card-wrapper.vue";

export default NumberCardWrapper;
